import SEOHead from '../../components/base/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Insights from './components/Insights';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import { useEffect } from 'react';

export default function HomePage() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Tesis Güvenlik Belgesi Danışmanlık",
    "description": "MSB onaylı Milli TGB, NATO TGB ve Özel TGB danışmanlık hizmetleri. Ankara merkezli profesyonel tesis güvenlik belgesi danışmanlığı.",
    "url": "https://tesisguvenlikbelgesi.com.tr",
    "logo": "https://tesisguvenlikbelgesi.com.tr/logo.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Ankara",
      "addressLocality": "Ankara",
      "addressRegion": "Ankara",
      "addressCountry": "TR"
    },
    "telephone": "+90-312-666-0636",
    "email": "info@tesisguvenlikbelgesi.com.tr",
    "priceRange": "$$",
    "areaServed": {
      "@type": "Country",
      "name": "Türkiye"
    },
    "serviceType": ["Milli TGB Danışmanlık", "NATO TGB Danışmanlık", "Özel TGB Danışmanlık", "Belge Yenileme", "Fiziki Güvenlik", "Personel Güvenlik Soruşturması"]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Tesis Güvenlik Belgesi Danışmanlık",
    "image": "https://tesisguvenlikbelgesi.com.tr/logo.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Ankara",
      "addressRegion": "Ankara",
      "addressCountry": "TR"
    },
    "telephone": "+90-312-666-0636",
    "openingHours": "Mo-Fr 09:00-18:00",
    "priceRange": "$$"
  };

  useEffect(() => {
    // Add structured data scripts
    const addStructuredData = (data: object, id: string) => {
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data);
    };

    addStructuredData(organizationSchema, 'organization-schema');
    addStructuredData(localBusinessSchema, 'local-business-schema');
  }, []);

  return (
    <>
      <SEOHead
        title="Tesis Güvenlik Belgesi Danışmanlık | MSB NATO TGB | Ankara"
        description="Ankara merkezli profesyonel TGB danışmanlık hizmeti. Milli TGB, NATO TGB, Özel TGB belgelendirme süreçlerinde uzman kadro ile hızlı ve güvenilir çözümler. MSB onaylı danışmanlık firması."
        keywords="tesis güvenlik belgesi, TGB danışmanlık, Milli TGB, NATO TGB, Özel TGB, MSB belgelendirme, savunma sanayii, güvenlik belgesi Ankara, personel güvenlik soruşturması, fiziki güvenlik"
        canonicalUrl="https://tesisguvenlikbelgesi.com.tr/"
        ogImage="https://public.readdy.ai/ai/img_res/3265beb3ad1286bf1ce629280c3881f4.jpg"
      />

      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <Insights />
        <ContactCTA />
        <Footer />
      </div>
    </>
  );
}